import '../../css/blocks/textandicon.css';

// Wait for the window to fully load before initializing
window.addEventListener('load', () => {
  const textandiconBlocks = document.querySelectorAll('.textandicon');
  
  if (textandiconBlocks.length) {
    // Initialize block-specific functionality here
  }
});
